import React, { useContext, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';

import { Actions, Categories, Labels } from '../../types/gtm';
import { DeleteAccountContext } from '.';
import Title from '../../components/Title';
import { ItemWebParental } from './components/ItemWebParental';

import { DivContent, DivHeader, DivBox } from './styles';

const DeleteParentalDetails = () => {
  const { subscriptionData } = useContext(DeleteAccountContext);
  const { user } = useAuth();

  window.dataLayer = window.dataLayer || [];

  useEffect(() => {
    window.dataLayer.push({
      event: 'customEventUserInteraction',
      event_category: Categories.DeleteAccount,
      event_action: Actions.Pageview,
      event_label: Labels.DeleteAccountParentalControlPage,
      bd_suser_code: user?.globoId,
    });
  }, [user]);

  return (
    <>
      <DivHeader>
        <Title>Controle Parental</Title>
        <p>
          Todas as contas de menores autorizados por você devem ser{' '}
          <strong>excluídas</strong>. <br /> Confira a seguir quais são os
          menores autorizados por você:
        </p>
      </DivHeader>
      <DivBox>
        <DivContent className="mcv3-card">
          <ItemWebParental
            underages={subscriptionData.responsibleForUnderages}
            globoId={user.globoId}
          />
        </DivContent>
      </DivBox>
    </>
  );
};

export default DeleteParentalDetails;
